/* src/app/module/users/add-user/add-insurance-details/add-insurance-details.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
h2 {
  margin-bottom: 20px;
  font-size: 24px;
}
h3 {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.custom-upload-button {
  margin-top: 33px;
  margin-bottom: 23px;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  border: 1px solid #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button:hover:not(:disabled) {
  background-color: #e67e00;
  border: 1px solid #e67e00;
  transform: translateY(-2px);
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
.section-spacer {
  height: 43px;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
::ng-deep ::placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  margin: 0;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(8, 12, 20, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-bar {
  width: 100px;
  height: 10px;
  background-color: black;
  animation: load 2s infinite;
}
@keyframes load {
  0% {
    width: 0;
  }
  100% {
    width: 100px;
  }
}
::ng-deep .p-dropdown {
  margin-bottom: 4px;
  height: 44px;
  margin-top: 4px;
}
::ng-deep .p-inputtext {
  margin-top: 4px;
  margin-bottom: 4px;
  height: 44px;
}
::ng-deep formly-validation-message {
  margin-top: 4px;
}
::ng-deep .p-datepicker {
  width: 300px !important;
  height: 335px !important;
  font-size: 12px;
  overflow: hidden;
}
::ng-deep .p-datepicker-group {
  flex-direction: column !important;
  width: 100% !important;
}
::ng-deep .p-datepicker-calendar {
  table-layout: fixed;
  width: 100% !important;
  font-size: 12px;
}
::ng-deep .p-datepicker td,
::ng-deep .p-datepicker th {
  padding: 0.25rem !important;
  text-align: center;
}
::ng-deep .p-datepicker-header {
  padding: 0.5rem;
  font-size: 13px;
}
/*# sourceMappingURL=add-insurance-details.component-34C4MPJY.css.map */
